import { render, staticRenderFns } from "./KyukaView.vue?vue&type=template&id=c47a6392&scoped=true"
import script from "./KyukaView.vue?vue&type=script&lang=js"
export * from "./KyukaView.vue?vue&type=script&lang=js"
import style0 from "./KyukaView.vue?vue&type=style&index=0&id=c47a6392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47a6392",
  null
  
)

export default component.exports